(function (h, o, u, n, d) {
  h = h[d] = h[d] || {
    q: [],
    onReady: function (c) {
      h.q.push(c);
    },
  };
  d = o.createElement(u);
  d.async = 1;
  d.src = n;
  n = o.getElementsByTagName(u)[0];
  n.parentNode.insertBefore(d, n);
})(
  window,
  document,
  "script",
  "https://www.datadoghq-browser-agent.com/us1/v5/datadog-rum.js",
  "DD_RUM",
);

window.DD_RUM.onReady(function () {
  const scriptTag = document.getElementById("dd-rum-script");
  const clientToken = scriptTag.dataset.token;
  const env = scriptTag.dataset.environment;
  const version = scriptTag.dataset.commit;
  const service = scriptTag.dataset.service;

  window.DD_RUM.init({
    clientToken,
    applicationId: "78304e57-aec0-48bc-ac8e-9eb21a0445b7",
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: "datadoghq.com",
    service,
    env,
    version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
    allowedTracingUrls: [
      /https:\/\/([a-z0-9-]+\.)?turquoise\.health/,
      // Match turquoiseconnect.health but exclude third-party services (e.g., Syrenis)
      (url) =>
        url.includes("turquoiseconnect.health") &&
        !url.startsWith("https://cscript-cdn-") &&
        !url.startsWith("https://ids"),
    ],
  });
});
